import { Injectable } from "@angular/core";
import { Select, Store } from "@ngxs/store";
import { BehaviorSubject, Observable } from "rxjs";
import { CloseSideMenu, OpenSideMenu, ToggleSideMenu } from "../ngxs/application/application.actions";
import { ApplicationGetterState } from "../ngxs/application/application-getter.state";

@Injectable({
  providedIn: 'root',
})
export class ApplicationService {
  @Select(ApplicationGetterState.getSideMenuOpened)
  sideMenuOpened$: Observable<boolean>;
  showSpinnerSubject$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(
    private store: Store
  ) {}

  openSideMenu() {
    this.store.dispatch(new OpenSideMenu());
  }

  closeSideMenu() {
    this.store.dispatch(new CloseSideMenu());
  }

  toggleSideMenu() {
    this.store.dispatch(new ToggleSideMenu());
  }
}